module.exports = "/_next/static/images/link-connector-f8832d19920132a3db0cdc037178dd9c.png";